module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAQCAYAAADagWXwAAAAAXNSR0IArs4c6QAAAJRJREFUGBljZsAEIkAhMSD+iyylDORcAeL/UJzNhCRbD2RrI/FRmFeBPJCuS0AcC8RqQAwHz4AskORkmAgzkMELxElA7AnEHED8DYg5gfg7EDMoAjHMEch0FLKDQAqRwSsQB6RACIhfADFI5ywon4UFyPgHxO+gNJBi+AHlg3WBBLACfHbSSifItTAQCWSwA/EjmAAA5gMcwk+7+gIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_facebook.png
// module id = 98
// module chunks = 0